/**
 * Normaliza uma data-calendário (sem componente horário relevante) para meio-dia UTC,
 * preservando o dia tal como o utilizador o vê no fuso local.
 *
 * O DatePicker produz a meia-noite local (ex.: 15/04 00:00 em Portugal = 14/04 23:00 UTC).
 * Quando esse instante é guardado em UTC e mais tarde formatado noutro contexto — como no
 * PDF, gerado no servidor que formata o valor em UTC — o dia "salta" para trás.
 * Ancorar a meio-dia UTC garante que o mesmo dia de calendário é apresentado em qualquer
 * fuso (de UTC-11 a UTC+11), tanto no ecrã como no PDF.
 */
export function normalizeDateOnly(value: Date | string | null | undefined): Date | undefined {
    if (!value) return undefined;
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return undefined;
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0));
}
